//src/components/dashboard/DashboardSidebar.js
import { useEffect, useMemo, useState } from "react";
import {
  MdChevronLeft,
  MdChevronRight,
  MdClose,
  MdDashboard,
  MdHomeWork,
  MdKeyboardArrowDown,
  MdStorefront
} from "react-icons/md";
import { Link, NavLink, useLocation } from "react-router-dom";
import { clearAuth } from "../../utils/auth";

const DashboardSidebar = ({
  isOpen,
  isCollapsed,
  onClose,
  onToggleCollapse,
}) => {
  const location = useLocation();
  const [openGroup, setOpenGroup] = useState("overview");

  const activeGroup = useMemo(() => {
    if (
      location.pathname.startsWith(
        "/dashboard/subscription-plans"
      )
    )
      return "overview";

    if (
      location.pathname.startsWith(
        "/dashboard/properties"
      )
    )
  return "properties";
    if (location.pathname.startsWith("/dashboard/profile")) return "account";
    return "overview";
  }, [location.pathname]);

  useEffect(() => {
    setOpenGroup(activeGroup);
  }, [activeGroup]);

  const handleLogout = () => {
    clearAuth();
    window.location.replace("/");
  };

  const menuGroups = [
    {
      key: "overview",
      label: "Overview",
      icon: MdDashboard,
      items: [
        {
          type: "link",
          label: "Dashboard",
          to: "/dashboard",
          end: true,
          icon: MdDashboard,
        },
          {
          type: "link",
          label: "Subscription Plans",
          to: "/dashboard/subscription-plans",
          icon: MdStorefront,
        },
      ],
    },
    {
      key: "properties",
      label: "Properti",
      icon: MdHomeWork,
      items: [
        {
          type: "link",
          label: "My Properties",
          to: "/dashboard/properties",
          icon: MdHomeWork,
        },
      ],
    },
  ];

  return (
    <>
      <aside
        className={`dashboard-sidebar ${isOpen ? "is-open" : ""} ${
          isCollapsed ? "is-collapsed" : ""
        }`}
        aria-label="Dashboard Sidebar"
      >
        <div className="dashboard-sidebar__header">
          <div className="dashboard-sidebar__header-actions">
            <button
              type="button"
              className="dashboard-sidebar__collapse-btn"
              onClick={onToggleCollapse}
              aria-label={isCollapsed ? "Perbesar sidebar" : "Minimize sidebar"}
              title={isCollapsed ? "Perbesar sidebar" : "Minimize sidebar"}
            >
              {isCollapsed ? (
                <MdChevronRight size={22} />
              ) : (
                <MdChevronLeft size={22} />
              )}
            </button>

            <button
              type="button"
              className="dashboard-sidebar__close-btn"
              onClick={onClose}
              aria-label="Tutup sidebar"
            >
              <MdClose size={22} />
            </button>
          </div>
          <Link to="/" className="dashboard-sidebar__brand" onClick={onClose}>
            <img
              src="/logo.png"
              alt="Logo"
              className="dashboard-sidebar__logo"
            />
          </Link>
        </div>

        <div className="dashboard-sidebar__body">
          <div className="dashboard-sidebar__section-label">Main Menu</div>

          <div className="dashboard-sidebar__groups">
            {menuGroups.map((group) => {
              const GroupIcon = group.icon;
              const groupOpen = openGroup === group.key;
              const groupActive = activeGroup === group.key;

              return (
                <div
                  key={group.key}
                  className={`dashboard-sidebar__group ${groupOpen ? "is-open" : ""}`}
                >
                  <button
                    type="button"
                    className={`dashboard-sidebar__group-btn ${
                      groupActive ? "is-active" : ""
                    }`}
                    onClick={() =>
                      setOpenGroup((prev) =>
                        prev === group.key ? "" : group.key,
                      )
                    }
                    aria-expanded={groupOpen}
                    title={group.label}
                  >
                    <span className="dashboard-sidebar__group-icon">
                      <GroupIcon size={20} />
                    </span>
                    <span className="dashboard-sidebar__group-text">
                      {group.label}
                    </span>
                    <MdKeyboardArrowDown
                      size={18}
                      className={`dashboard-sidebar__group-chevron ${
                        groupOpen ? "is-open" : ""
                      }`}
                    />
                  </button>

                  <div className="dashboard-sidebar__submenu">
                    {group.items.map((item) => {
                      const ItemIcon = item.icon;

                      if (item.type === "action") {
                        return (
                          <button
                            key={item.label}
                            type="button"
                            className="dashboard-sidebar__sublink dashboard-sidebar__sublink--button"
                            onClick={() => {
                              item.onClick?.();
                              onClose();
                            }}
                          >
                            <ItemIcon size={18} />
                            <span>{item.label}</span>
                          </button>
                        );
                      }

                      return (
                        <NavLink
                          key={item.to + item.label}
                          to={item.to}
                          end={item.end}
                          className={({ isActive }) =>
                            `dashboard-sidebar__sublink ${
                              isActive ? "active" : ""
                            }`
                          }
                          onClick={onClose}
                        >
                          <ItemIcon size={18} />
                          <span>{item.label}</span>
                        </NavLink>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </aside>

      <div
        className={`dashboard-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
    </>
  );
};

export default DashboardSidebar;
